'use client';

import { useRouter } from 'next/navigation';
import { updateProfile } from '@/app/actions/profile';
import { callAction } from '@/lib/call-action';
import { EditableName } from './EditableName';
import { PageLink } from './PageLink';
import { TaglineEditor } from './TaglineEditor';

/**
 * The owner's name and tagline, edited on the page. The link is shown to copy
 * and share; it is renamed on Settings.
 */
export function OwnerIdentity({
  name,
  username,
  tagline,
  ambassador,
}: {
  name: string;
  username: string;
  tagline: string | null;
  ambassador?: boolean;
}) {
  const router = useRouter();

  const saveName = async (next: string) => {
    const result = await callAction(() => updateProfile({ name: next }, username));
    if (!result.success) return result.error;
    router.refresh();
    return null;
  };

  const saveTagline = async (next: string | null) => {
    const result = await callAction(() => updateProfile({ bio: next ?? '' }, username));
    if (!result.success) return 'Could not save — your line is still here, try again';
    router.refresh();
    return null;
  };

  return (
    <div className="flex flex-col gap-3">
      <EditableName name={name} ambassador={ambassador} onSave={saveName} />
      <TaglineEditor tagline={tagline} onSave={saveTagline} />
      <PageLink username={username} own={username} />
    </div>
  );
}
